import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    page:1,
    olddata:[]
   
    
}

const mutations={



    addProductPrice(state,value){

        post(urls.admin.price.add,value).then((result)=>{

            state.result= result

            
          
         
             
          });
    },

   
   
   
}
const  actions={

    addProductPriceAction(context,value){
       
        
        context.commit("addProductPrice",value)
       
    },

   
    
   
  
    
  
    
   

}

export default {state,mutations,actions}